import { render, staticRenderFns } from "./CustomerDropdown.vue?vue&type=template&id=6840a614"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports